export const DEFAULT_REFERENCE = 'TQE';
